import { b } from "../../useActions-BIIcXXS6.js";
import { a as X } from "../../logger-DVwg4Wor.js";
import { a as v } from "../../useLoadMore-Dw7GDu8a.js";
import { u as le } from "../../useLoadMore-Dw7GDu8a.js";
import { useState as R, useCallback as h, useMemo as y, useEffect as A, useRef as N } from "preact/hooks";
import { s as P } from "../../index.es-B8mbAxS4.js";
import { p as x } from "../../parseNumber-QA48nJLp.js";
function K(t) {
  const r = v((e) => e.response);
  return t && Array.isArray(t) || t && X(t) ? t : r;
}
function Q(t, r) {
  const e = t.data?.filter((d) => d.selected).length ?? 0, { active: o } = {
    active: e > 0,
    ...r
  }, [s, c] = R(o), { toggleProductFilter: i } = b(), l = h(() => {
    c(!s);
  }, [s]);
  return {
    /** Active value */
    active: s,
    /** Selected filters count */
    selectedFiltersCount: e,
    /** Toggle active function */
    toggleActive: l,
    /** Toggle product filter function */
    toggleProductFilter: i
  };
}
function W() {
  const { loading: t, facets: r } = v((e) => ({
    loading: e.loading,
    facets: e.response?.products?.facets ?? []
  }));
  return {
    /** Loading state */
    loading: t,
    /** Array of facets*/
    facets: r
  };
}
function O(t, r) {
  const e = r - t;
  return !isNaN(e) && e > 0 ? new Array(r - t).fill(void 0).map((o, s) => s + t) : [];
}
function Y(t) {
  const { query: r, products: e } = v((o) => ({
    query: o.query,
    products: o.response.products
  }));
  return y(() => {
    if (!e)
      return {
        totalPages: 0,
        resultsFrom: 0,
        resultsTo: 0,
        pages: []
      };
    const o = r.products?.from ?? 0, s = t?.width ?? 1 / 0, c = Math.max(Math.floor(s - 1) / 2, 1), i = e.size > 0 ? Math.floor(o / e.size) + 1 : 1, l = e.size > 0 ? Math.ceil(e.total / e.size) : 0, d = (w) => w >= i - c && w <= i + c, n = o + 1, a = Math.min(o + e.total, e.total), u = {
      from: o,
      page: i,
      current: !0
    }, f = (w) => ({
      from: (w - 1) * e.size,
      page: w,
      current: w === i
    }), m = i > 1 ? f(i - 1) : void 0, p = i < l ? f(i + 1) : void 0, g = i - c - 1 > 1 ? f(1) : void 0, S = i + c + 1 < l ? f(l) : void 0, F = O(1, l + 1).filter(d).map(f);
    return !g && F[0]?.page === 2 && F.unshift(f(1)), !S && F[F.length - 1]?.page === l - 1 && F.push(f(l)), {
      totalPages: l,
      resultsFrom: n,
      resultsTo: a,
      current: u,
      prev: m,
      next: p,
      first: g,
      last: S,
      pages: F
    };
  }, [r, e, t?.width]);
}
function ee() {
  const [t, r] = R([]), [e, o] = R([]);
  return A(() => {
    P(async (s) => {
      const { products: c, segments: i } = await s.getSearchSessionParams();
      r(i ?? []), o(c?.personalizationBoost ?? []);
    });
  }, []), {
    segments: t,
    boost: e
  };
}
function T() {
  const { facets: t } = v((n) => ({
    facets: n.response.products?.facets ?? []
  })), { replaceFilter: r, toggleProductFilter: e } = b(), o = h(
    (n) => {
      const a = t?.find((u) => u.type === "stats" && u.field === n);
      if (a && "min" in a && "max" in a)
        return a;
    },
    [t]
  ), s = h(
    (n) => t?.find((a) => a.field === n)?.name ?? n,
    [t]
  ), c = h((n) => "field" in n && (n.value instanceof Array || n.range instanceof Array), []), i = h((n) => ({
    ...n,
    range: n.range?.map((a) => ({
      gt: a.gt ? Number(a.gt) : a.gt,
      gte: a.gte ? Number(a.gte) : a.gte,
      lt: a.lt ? Number(a.lt) : a.lt,
      lte: a.lte ? Number(a.lte) : a.lte
    }))
  }), []), l = h(
    (n) => (n.value ?? []).map((u) => ({
      value: u,
      field: n.field,
      name: s(n.field),
      filter: i(n),
      remove: () => {
        e(n.field, u, !1);
      }
    })),
    [i, s, e]
  ), d = h(
    (n) => (n.range ?? []).map((u) => {
      const f = u.gte ?? u.gt ?? o(n.field)?.min, m = u.lte ?? u.lt ?? o(n.field)?.max;
      if (f !== void 0 && m !== void 0)
        return {
          value: `${f} - ${m}`,
          field: n.field,
          name: s(n.field),
          filter: i(n),
          remove: () => {
            r(n.field, void 0);
          }
        };
    }).filter(Boolean),
    [i, o, s, r]
  );
  return {
    selectFilters: c,
    toValueFilter: l,
    toRangeFilter: d
  };
}
function C() {
  const { filter: t } = v((l) => ({
    filter: l.query.products?.filter ?? []
  })), { updateSearch: r } = b(), { selectFilters: e, toValueFilter: o, toRangeFilter: s } = T(), c = y(() => t ? t.filter(e).flatMap((l) => "value" in l ? o(l) : "range" in l ? s(l) : []).filter(Boolean) : [], [t, e, s, o]), i = h(() => {
    r({
      products: {
        filter: []
      }
    });
  }, [r]);
  return {
    /** Selected filters array. */
    filters: c,
    /** Should remove all selected filters. */
    removeAll: i
  };
}
function k(t) {
  const { replaceFilter: r } = b(), { query: e, products: o } = v((u) => ({
    query: u.query,
    products: u.response.products
  })), s = o?.facets?.find((u) => u.id === t);
  if (!s)
    return {
      min: 0,
      max: 0,
      range: [0, 0],
      updateRange: () => {
      }
    };
  const c = e.products?.filter?.find((u) => u.field === s.field), i = c?.range ? c.range[0] : void 0, l = typeof i == "object" && ("gte" in i || "lte" in i) ? [x(i.gte), x(i.lte)] : [void 0, void 0], d = "min" in s ? Math.floor(s.min) : 0, n = "max" in s ? Math.ceil(s.max) : 0, a = ([u, f]) => {
    const m = u !== void 0 ? Math.floor(u) : void 0, p = f !== void 0 ? Math.ceil(f) : void 0, g = m !== void 0, S = p !== void 0;
    (d === m || !g) && (n === p || !S) ? r(s.field, void 0) : (d === m || !g) && S ? r(s.field, {
      lte: p.toString()
    }) : (n === p || !S) && g ? r(s.field, {
      gte: m.toString()
    }) : g && S && r(s.field, {
      gte: m.toString(),
      lte: p.toString()
    });
  };
  return {
    /** Min value */
    min: d,
    /** Max value */
    max: n,
    /** Range value */
    range: [l[0] ?? d, l[1] ?? n],
    /** Update range function */
    updateRange: a
  };
}
function te(t, r) {
  const { min: e, max: o, range: s, updateRange: c } = k(t), { filters: i } = C(), l = y(() => {
    const u = i.find((g) => g?.filter?.range);
    let f = null;
    if (u) {
      const g = u.filter.range?.[0];
      f = [x(g?.gte), x(g?.lte)];
    }
    const m = [];
    let p = Math.floor(e / r) * r;
    for (; p < o; ) {
      const g = p + r, S = f && f[0] === p && f[1] === g;
      m.push({
        min: p,
        max: g,
        selected: S
      }), p = g;
    }
    return m;
  }, [i, e, o, r]), d = (u) => {
    c([u, s[1]]);
  }, n = (u) => {
    c([s[0], u]);
  }, a = e !== s[0] || o !== s[1];
  return {
    /** Minimum value */
    min: e,
    /** Maximum value */
    max: o,
    /** Range value */
    range: s,
    /** Update range function */
    updateRange: c,
    /** Ranges */
    ranges: l,
    /** Handle min change */
    handleMinChange: d,
    /** Handle max change */
    handleMaxChange: n,
    /** Is selected */
    isSelected: a
  };
}
function ne() {
  const { products: t, keywords: r } = v((e) => e.response);
  return {
    /** Array of products */
    products: t ?? { hits: [], total: 0 },
    /** Array of keywords */
    keywords: r ?? { hits: [], total: 0 }
  };
}
function re() {
  const t = v((e) => e.query.products?.filter);
  return y(() => t ? t.reduce((e, o) => e + (Array.isArray(o.value) ? o.value.length : 1), 0) : 0, [t]);
}
function L(t) {
  return t && !Number.isNaN(t) ? t : 0;
}
function oe(t, r) {
  const { from: e, size: o, total: s } = v((n) => ({
    from: L(n.query.products?.from ?? 0),
    size: L(n.response?.products?.size ?? r),
    total: L(n.response?.products?.total ?? 0)
  })), { updateSearch: c } = b(), i = e + o, l = [...t].reverse().filter((n) => n + r < s);
  return {
    /** from value */
    from: e,
    /** to value */
    to: i,
    /** total value */
    total: s,
    /** size value */
    size: o,
    /** Array of size options */
    sizeOptions: l,
    /** Should be called when size is changed */
    handleSizeChange: (n) => {
      c({
        products: {
          size: x(n)
        }
      });
    }
  };
}
function q(t, r) {
  return t.length !== r.length ? !1 : t.every((e) => r.find((o) => e.field === o.field && e.order === o.order));
}
function se(t) {
  const r = v((c) => c.query), { updateSearch: e } = b();
  return {
    /** Active sort */
    activeSort: t.find((c) => q(c.value.sort, r.products?.sort || []))?.id ?? t[0]?.id,
    /** Set sort function */
    setSort: (c) => {
      const i = t.find((l) => l.id === c);
      i && e({
        products: {
          sort: i.value.sort
        }
      });
    }
  };
}
const M = window.SpeechRecognition || window.webkitSpeechRecognition, j = !!(M && typeof M == "function");
function V() {
  return {
    listening: !1,
    startListening: () => {
    },
    stopListening: () => {
    }
  };
}
function B({
  language: t = "en-US",
  interimResults: r = !1,
  onResult: e,
  onError: o
} = {}) {
  const [s, c] = R(!1), i = N(null), l = h(() => {
    const n = new M();
    n.lang = t, n.interimResults = r, n.onstart = () => c(!0), e && (n.onresult = (a) => {
      const { transcript: u } = a.results?.[0]?.[0];
      e(u);
    }), o && (n.onerror = (a) => o(a.error)), n.onend = () => c(!1), i.current = n, n.start();
  }, [t, r, o, e]), d = h(() => {
    i.current?.stop();
  }, [i]);
  return {
    listening: s,
    startListening: l,
    stopListening: d
  };
}
const ie = j ? B : V;
function D(t, r) {
  if (!t.length || !r.length) return [];
  const e = r.reduce((o, s) => (o[s] = {}, o), {});
  return t.forEach((o) => {
    o.customFields?.forEach(({ key: s, value: c }) => {
      const i = s.toLowerCase();
      r.includes(i) && (e[i][c] = e[i][c] || [], e[i][c].push(o));
    });
  }), Object.entries(e).filter((o) => Object.keys(o[1]).length).map(([o, s]) => ({
    field: o,
    options: Object.entries(s).map(([c, i]) => ({
      value: c,
      skus: i,
      unavailable: !1,
      selected: !1
    }))
  }));
}
function E(t, r) {
  return t.length ? t.map(({ field: e, options: o }) => ({
    field: e,
    options: o.map((s) => {
      const c = !s.skus?.some((l) => Object.entries(r).every(([d, n]) => d === e ? !0 : l.customFields?.find((u) => u.key.toLowerCase() === d)?.value === n)), i = r[e] === s.value;
      return {
        ...s,
        unavailable: c,
        selected: i
      };
    })
  })) : [];
}
const z = ["4XS", "3XS", "2XS", "XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "XXXL", "3XL", "4XL"];
function U(t) {
  if (z.includes(t))
    return 1e3 + z.indexOf(t);
  const r = parseFloat(t);
  return isNaN(r) ? t : r;
}
function _(t, r) {
  return [...r].sort((e, o) => {
    const [s, c] = [e.value, o.value].map(U);
    return s < c ? -1 : 1;
  });
}
function ce(t = [], r = []) {
  const [e, o] = R({}), s = y(() => D(t, r).map(({ field: n, options: a }) => ({
    field: n,
    options: _(n, a)
  })), [t, r]), c = y(() => E(s, e), [s, e]), i = h((d, n) => {
    o((a) => {
      const u = { ...a };
      return u[d] === n ? delete u[d] : u[d] = n, u;
    });
  }, []), l = y(() => Object.keys(e).filter((a) => e[a]).length === 0 ? [] : c.filter(({ field: a }) => e[a]).map(({ field: a, options: u }) => {
    const f = e[a];
    return u.find((p) => p.value === f)?.skus ?? [];
  }).reduce((a, u) => a.filter((f) => u.includes(f))), [c, e]);
  return { swatches: c, toggleOption: i, matchedSkus: l };
}
export {
  j as speechToTextSupported,
  b as useActions,
  K as useDecoratedSearchResults,
  Q as useFacet,
  W as useFacets,
  le as useLoadMore,
  v as useNostoAppState,
  Y as usePagination,
  ee as usePersonalization,
  C as useProductFilters,
  k as useRange,
  te as useRangeSelector,
  ne as useResponse,
  re as useSelectedFiltersCount,
  oe as useSizeOptions,
  se as useSort,
  ie as useSpeechToText,
  ce as useSwatches
};
